import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { Category } from './model'

export interface CategoryStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllCategorySuccessEvent = {
    type: 'GetAllCategorySuccessEvent',
    build: (payload: Category[]) => buildStateEvent(GetAllCategorySuccessEvent.type, payload)
}
